const isVerboseEnabled = () => {
  if (process.env.NODE_ENV !== 'production') {
    return true;
  }

  try {
    return Boolean(window.localStorage.getItem('debug'));
  } catch {
    return false;
  }
};

const alwaysOn = () => true;

const writeTo =
  (method, isEnabled) =>
  (...args) => {
    if (isEnabled()) {
      console[method](...args);
    }
  };

export const logger = {
  debug: writeTo('debug', isVerboseEnabled),
  info: writeTo('info', isVerboseEnabled),
  warn: writeTo('warn', alwaysOn),
  error: writeTo('error', alwaysOn),
};
